<template>
  <layout-form>
    <input-name />
    <input-tel />
    <input-email />
  </layout-form>
</template>

<script>
import LayoutForm from '@/lib//Layout/Form'

import InputName from './InputName'
import InputTel from './InputTel'
import InputEmail from './InputEmail'

export default {
  components: {
    LayoutForm,
    InputName,
    InputTel,
    InputEmail
  }
}
</script>
